const installablePlugins = [
	{
		slug: "yoast-seo-for-wordpress-free",
		displayName: "Yoast SEO Free",
		isDefaultSelection: true,
	},
];

export default installablePlugins;
